const openCloseAccordionSlides = function(e){
    let parents = document.querySelectorAll('.main-product__accordion');
    if(e){
        let closest = e.target.closest('.main-product__accordion');
        closest.setAttribute('accordion-select', '');
        parents = document.querySelectorAll('.main-product__accordion[accordion-select]');
        closest.removeAttribute('accordion-select')
    }
    parents.forEach((parent) => {
        let openSlides = parent.querySelectorAll('.main-product__accordion-li[data-status="open"]');
        let ul = parent.querySelector('.main-product__accordion-ul');

        ul.setAttribute('data-transitioning', 'true')

        let liElement;
        let newStatus;
        if(e && e.target){
            liElement = e.target.closest('.main-product__accordion-li') ? e.target.closest('.main-product__accordion-li') : e.target;
            newStatus = liElement.getAttribute('data-status') == 'open' ? 'closed' : 'open';
        }

        let timeoutLength = openSlides.length > 0 && newStatus == "open" ? 1000 : 500;

        if(openSlides.length > 0){
            openSlides.forEach((openSlide) => {
                openSlide.setAttribute("data-status", closed);
                openSlide.querySelector('.main-product__accordion-body-container').style.height = "0"            
            })
        }

        const openSlide = function(){
            liElement.setAttribute('data-status', 'open');
            let liBody = liElement.querySelector('.main-product__accordion-body-container');
            let bodyHeight = parseFloat(window.Branch.functions.getStyle(liBody.querySelector('.main-product__accordion-body-inner-container'), 'height').replace('px', ''));
            liBody.style.height = `${bodyHeight}px`
        }

        setTimeout(() => {
            ul.setAttribute('data-transitioning', 'false')
        }, `${timeoutLength}`);


        if(newStatus == 'open' && e && e.target){
            if(openSlides.length > 0){ 
                setTimeout(() => {
                openSlide()
                }, "500");
            } else {
                openSlide()
            }
        }
    })
}

window.Branch = window.Branch || {};
window.Branch.product = window.Branch.product || {};

window.Branch.product.updateDiscountCodePrice = function(variant, product, origin, bundlePricingDataArray, placement) {
    let item = document.querySelector(`#main-product-item-${product.id}`);
    let priceData;

    if(origin == 'bundle-builder-pop-up'){
        priceData = bundlePricingDataArray.find(obj => Object.keys(obj).includes(`${variant.id}`))[`${variant.id}`];

    } else if(placement && placement == 'side-cart'){
        priceData = JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText)[`${product.id}`][`${variant.id}`];

    } else {
        priceData = JSON.parse(document.querySelector(`.variant-pricing[data-product-handle="${product.handle}"]`).innerText)[`${variant.id}`];
    }
    let originalPrice = priceData.opx == "" ? null : priceData.opx;
    let currentPrice = priceData.cpx;
    let discountMessage = priceData.dcmx == "" ? null : priceData.dcmx;

    if(origin == 'bundle-builder-pop-up'){
        let discount_multiplier = ((100 - parseInt(priceData.bdx))/100);
        originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
        currentPrice = priceData.cpx * discount_multiplier;
    }

    if(originalPrice == currentPrice){
        originalPrice = null;
    }

    let priceContainers = item.querySelectorAll('.main-product .main-product__title-review-price-container .price');
    if(priceContainers.length > 0){
        priceContainers.forEach((priceContainer) => {
            let priceParent = priceContainer.parentElement;
            priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').innerHTML = Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','');
        
            let retail = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail');
            let dataRetail = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]');
            let offPecentage = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]');
            let offAmount = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]');
            let discountCodeOffPercent = priceParent.querySelector('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]');
        
            if(originalPrice != null){
              var retailPrice = Shopify.formatMoney(originalPrice, Simplistic.formatMoney).replace('.00', '').replace(' ','');
              var percentDiscount = Math.round( (((originalPrice - currentPrice) * 100 ) / originalPrice) );
              var moneyDiscount = Shopify.formatMoney((originalPrice - currentPrice), Simplistic.formatMoney).replace('.00', '').replace(' ','');
                  
              
        
              if(discountMessage && discountMessage != null && discountCodeOffPercent){
                var modifiedMessage = discountMessage.replace('<p>',`<p>Save ${percentDiscount}% `)
                discountCodeOffPercent.innerHTML = modifiedMessage;
              }
        
              if(dataRetail){
                dataRetail.innerHTML = `${retailPrice}`;
            };

              if(retail){retail.setAttribute('data-visible', true)};
              if(offPecentage){offPecentage.innerHTML = `${percentDiscount}%`};
              if(offAmount){offAmount.innerHTML = moneyDiscount};
        
            } else {
                if(dataRetail){dataRetail.innerHTML = ''};
                if(retail){retail.setAttribute('data-visible', false)};
                if(offPecentage){offPecentage.innerHTML = ''};
                if(offAmount){offAmount.innerHTML = ''};
                if(discountCodeOffPercent){discountCodeOffPercent.innerHTML = ''};
            }
        
        })
    }
  };

window.Branch.product.initAccordion = function(){
    const accordions = document.querySelectorAll('.main-product .main-product__accordion:not([data-init="true"]');
    if(accordions.length > 0){
        accordions.forEach((accordion) => {
            accordion.setAttribute('data-init', true);
            const accordionSlides = accordion.querySelectorAll('.main-product__accordion-li');
            if(accordion && accordionSlides.length > 0){
                accordionSlides.forEach((accordionSlide) => {
                    accordionSlide.querySelector('.main-product__accordion-header-container').addEventListener("click", openCloseAccordionSlides);
                })
            }
        })
    }
}


const returnMaxHeight = function(colorSwatchHeads){
    let maxHeight = 0;
    colorSwatchHeads.forEach((colorSwatchHead) => {
        let colorSwatchHeadHeight = colorSwatchHead.offsetHeight;
        if(colorSwatchHeadHeight > maxHeight){
            maxHeight = colorSwatchHeadHeight;
        }
    })
    return maxHeight;
}

const largestMultipleBelow = function(number, divisor) {
    const remainder = number % divisor;
    return number - remainder;
}

const setCustomContainerWidth = function(colorSwatch){
    let custom_option_present = colorSwatch.closest('.swatches-container[data-custom-color-swatch-options="true"]') ? true : false;
    if(custom_option_present){
        let colorCustomSwatchContainers = colorSwatch.querySelectorAll('.custom-color-swatch-option__new-swatch-container, .custom-color-swatch-option__regular-swatch-container');

        colorCustomSwatchContainers.forEach((colorCustomSwatchContainer) => {
            colorCustomSwatchContainer.style.width = 'unset'
            setTimeout(() => {
                const finalNumber = largestMultipleBelow(colorCustomSwatchContainer.offsetWidth + 17, 47)
                colorCustomSwatchContainer.style.width = `${finalNumber - 17}px`
            }, 250)
        })
        
    }
}

window.Branch.product.customSwatchContainerResize = function(selector){
    let colorSwatches = document.querySelectorAll(`${selector} .swatches-container .swatches-container__color-swatches-container`);
    if(colorSwatches.length > 0){
        colorSwatches.forEach((colorSwatch) => {
            setCustomContainerWidth(colorSwatch);
        })
    }
}

const bottomRowAddAttribute = function(colorSwatch){
    let lowestElementDistance = 0;
    let elementDistances = [];
    colorSwatch.querySelectorAll('.swatch').forEach((swatchUnit) => {
        let swatchElementsAll = swatchUnit.querySelectorAll('.swatch-element');
        swatchElementsAll.forEach((swatchElement) => {
            swatchElement.setAttribute('bottom-row', false);
            swatchElement.setAttribute('data-element-in-row-has-label', false);
            elementDistances.push(parseInt(swatchElement.getBoundingClientRect().top));
            if(swatchElement.getBoundingClientRect().top > lowestElementDistance) {
                lowestElementDistance = parseInt(swatchElement.getBoundingClientRect().top)
            }
        });

        let uniqelementDistances = [...new Set(elementDistances)];
        uniqelementDistances.forEach((distance) => {
            let distanceHasLabel = false;
            swatchElementsAll.forEach((swatchElement) => {
                if(parseInt(swatchElement.getBoundingClientRect().top) == distance) {
                    if(swatchElement.getAttribute('data-label') == "true"){
                        distanceHasLabel = true;
                    }
                }
            });

            swatchElementsAll.forEach((swatchElement) => {
                if(parseInt(swatchElement.getBoundingClientRect().top) == lowestElementDistance) {
                    swatchElement.setAttribute('bottom-row', true);
                };

                if(parseInt(swatchElement.getBoundingClientRect().top) == distance) {
                    swatchElement.setAttribute('data-element-in-row-has-label', distanceHasLabel);
                }
            })
        })    
    });
}

const setSwatchHeaderStyling = function(colorSwatchHeads, colorSwatch){
    let custom_option_present = colorSwatch.closest('.swatches-container[data-custom-color-swatch-options="true"]') ? true : false;
    let third_custom_option_present = colorSwatch.querySelectorAll('.custom-color-swatch-option__new-swatch-container[data-index="1"]').length > 0 ? true : false;

    if(custom_option_present == true){
        let customHeads = colorSwatch.querySelectorAll('.custom-color-swatch-option .head');
        let customHeadPrimary = colorSwatch.querySelector('.head.head--parent');
        let maxHeight = returnMaxHeight(customHeads);
        customHeads.forEach((customHead) =>{
            customHead.style.top = `-${maxHeight - 8}px`;
            customHead.closest('.custom-color-swatch-option').style.minWidth = `${customHead.offsetWidth + 2}px`
        });
        let colorSwatches = colorSwatch.querySelectorAll('.swatch');
        colorSwatches[0].style.marginTop = `${-16 + (maxHeight - 14)}px`;
        if(colorSwatches.length > 1){
            colorSwatches.forEach((loopColorSwatch, loopIndex) => {
                if(loopIndex > 0){
                    loopColorSwatch.style.marginTop = `${maxHeight + 10}px`;
                }
            })
        }
        customHeadPrimary.style.top = `${-14 - (maxHeight - 24)}px`;
    } else {
        let maxHeight = returnMaxHeight(colorSwatchHeads);
        colorSwatchHeads.forEach((colorSwatchHead) =>{
            colorSwatchHead.style.top = `-${maxHeight + 12}px`;
            colorSwatchHead.closest('.swatch').style.minWidth = `${colorSwatchHead.offsetWidth + 2}px`
        });
        colorSwatch.style.marginTop = `${maxHeight - 8}px`;
    };
}

function checkElementHeight(colorSwatchHeads, colorSwatch) {
    var element = colorSwatchHeads[0];
    
    if (element.offsetHeight > 0) {
        setTimeout(function() {
            setSwatchHeaderStyling(colorSwatchHeads, colorSwatch);
        }, 500);
    } else {
        setTimeout(function() {
            checkElementHeight(colorSwatchHeads, colorSwatch);
        }, 500);
    }
}

window.Branch.product.resizeSwatchesHeader = function(parentSelector){
    setTimeout(function(){
        let colorSwatches = document.querySelectorAll(`${parentSelector} .swatches-container .swatches-container__color-swatches-container`);
        if(colorSwatches.length > 0){
            colorSwatches.forEach((colorSwatch) => {
                let colorSwatchHeads = colorSwatch.querySelectorAll('.swatch .head ');
                if(colorSwatchHeads.length > 1){
                    checkElementHeight(colorSwatchHeads, colorSwatch);
                }
                bottomRowAddAttribute(colorSwatch);
            })
        }
    },
    500)
  }

  window.Branch.product.formatSwatches = function(format_options){
   
    if(!format_options){
        format_options = {};

        format_options['swatches_selector'] = `.main-product .swatches-container__color-swatches-container`;
        format_options['swatches_container_parent_selector'] = '.swatches-container'
        format_options['swatch_width'] = 47;
        format_options['divider_width'] = 41;
    }

    const swatches = document.querySelectorAll(`${format_options.swatches_selector}`);
        swatches.forEach((swatch) => {
    swatch.removeAttribute('data-wrapped');
      let isQuickView = swatch.closest('.main-product[data-quick-view="true"]') ? true : false;
      let buttonWidth = 0
      if(format_options.not_hidden_button_container != null && swatch.closest(`${format_options.swatches_container_parent_selector}`).querySelectorAll(`${format_options.not_hidden_button_container}`).length > 0){
        buttonWidth = swatch.closest(`${format_options.swatches_container_parent_selector}`).querySelector(`${format_options.not_hidden_button_container}`).offsetWidth + 10;
      }
      if(format_options['button_width'] == 0){
        buttonWidth = 0;
      }
      let width = swatch.closest(`${format_options.swatches_container_parent_selector}`).offsetWidth - buttonWidth;
      if(isQuickView == true){
        let currentWindowWidth = window.Branch.functions.returnWindowWidth();
        width = currentWindowWidth >= 900 ? ((currentWindowWidth - 34) * 0.55) - 40 - 24 : currentWindowWidth - 80;
        if(currentWindowWidth >= 1014){
            width = (980 * 0.55) - 40 - 24;
        }
      }
      
      let numberOfSwatches = swatch.querySelectorAll('.swatch-element.color').length;
      
      if(numberOfSwatches > 0){
        let swatchWidth = format_options.swatch_width;
        let dividerWidth = format_options.divider_width;
        let customSwatchUnits = swatch.querySelectorAll('.swatch.color[role="group"] .custom-color-swatch-option');  
        let widthNeededToBeOnOneLine = dividerWidth + (numberOfSwatches * swatchWidth);

        if(width > widthNeededToBeOnOneLine){
          swatch.setAttribute('data-wrapped', false)
        } else {
          swatch.setAttribute('data-wrapped', true)
        }

        if(customSwatchUnits.length > 0 && !swatch.closest('.main-product') && !swatch.closest('.variant-inspect')){
          let customNumberOfSwatches = 0;
          let swatchCustom = swatch.querySelector('.swatch.color[role="group"][data-custom-color-swatch-option="true"]')

          customSwatchUnits.forEach((customSwatchUnit) => {
            customNumberOfSwatches = customNumberOfSwatches + customSwatchUnit.querySelectorAll('.swatch-element.color').length
          })
           let customWidthNeededToBeOnOneLine = dividerWidth + (customNumberOfSwatches * swatchWidth);
           if(width > customWidthNeededToBeOnOneLine){
            swatchCustom.setAttribute('data-wrapped', false)
          } else {
            swatchCustom.setAttribute('data-wrapped', true)
          }
        }
      }


      if(swatch.getAttribute('data-init') == "false"){
        swatch.setAttribute('data-init', 'true');
      }
    });
  }

  window.Branch.product.updateVariantSwatchTitles = function(mainProductSwatches, variant, productId, variantTextReplacementMetafield){
    if(variant){
        mainProductSwatches.forEach((mainProductSwatch, index) => {
            let variantText = variant[`option${index + 1}`];
            if(variantText && variantText != ""){
            let optionVarNameSpan = mainProductSwatch.querySelector('.head span.opt-var-name');
            let optionVarTitleSpan = mainProductSwatch.querySelector('.head span.opt-var-title');
            let variantTextStripped = window.Branch.functions.stripVariantText(variantText, variantTextReplacementMetafield);
            optionVarNameSpan.classList.add('active')
            optionVarNameSpan.innerHTML = window.Branch.functions.capitalizeWords(variantTextStripped);
            if(optionVarTitleSpan){
                let customColorSwatchData = document.querySelector(`#custom-color-swatch-data--${productId}`) ? JSON.parse(document.querySelector(`#custom-color-swatch-data--${productId}`).innerText) : null;
                if(customColorSwatchData){
                let variantTextHandleized = variantText.toLowerCase().replaceAll(' ', '-');
                let variantTitleText = customColorSwatchData[`${variantTextHandleized}`];
                optionVarTitleSpan.innerHTML = `${variantTitleText}: `;

                }
            }
            }
        })
    }
  }

const initEpigraphButtons = function(){
    let epigraphInstances = document.querySelectorAll('epigraph-ar');
    if(epigraphInstances.length > 0){
        epigraphInstances.forEach((epigraphInstance) => {
            epigraphInstance.addEventListener('click', function(e){
                e.preventDefault();
                e.stopPropagation();
            })
        })
    }
}

const formatReviewsNumber = function(){
    let reviewNumbers = document.querySelectorAll('.main-product .stamped-badge-caption');
    if(reviewNumbers.length > 0){
        reviewNumbers.forEach((reviewNumber) => {
            let numberOfReviews = parseInt(reviewNumber.getAttribute('data-reviews'));
            if(numberOfReviews > 999){
                let number = reviewNumber.childNodes[0];
                let formattedNumber = window.Branch.functions.numberWithCommas(numberOfReviews)
                number.nodeValue = `${formattedNumber}`
            }
        })
    }
}

window.Branch.product.formatPreOrderSwatch = function(id){
    let preOrderSwatches = document.querySelectorAll(`.main-product .pre-order-swatch:not([data-repositioned="true"])`);
    if(id){
        preOrderSwatches = document.querySelectorAll(`.main-product #main-product-item-${id} .pre-order-swatch:not([data-repositioned="true"])`);
    }

    if(preOrderSwatches.length > 0){
        preOrderSwatches.forEach((preOrderSwatch) => {
            let outerPrice = preOrderSwatch.closest('.price');
            let outerPriceWidth = outerPrice.closest('.price-installments-wrapper').offsetWidth; 
            let maxWidth = 0;

            if(outerPrice.querySelector('.price__discount-message')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.price__discount-message').offsetWidth);
            }

            if(outerPrice.querySelector('.retail')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.retail').offsetWidth) + 6;
            }

            if(outerPrice.querySelector('.deal')){
                maxWidth = maxWidth + parseInt(outerPrice.querySelector('.deal').offsetWidth);
            };

            // console.log('maxWidth', maxWidth)

            preOrderSwatch.setAttribute('data-adjusted', true);
            
            if(outerPriceWidth > 0){
                preOrderSwatch.style.maxWidth = `${outerPriceWidth - maxWidth}px`;
            }
        })
    }
}

function findCheckedRadioIndex(elements) {
    return [...elements].findIndex(element => element.querySelector('input[type="radio"]:checked'));
}

window.Branch.product.returnFirstSecondVariant = function(product, origin, selector){
    let firstSecondVariant = [];
    let option_number = 1;
    let firstVariant = product.variants.find(obj => obj.available === true);
    let secondVariant;
    let secondSwatchIndex;
    let secondSwatchValue;
    let firstVariantSiblingSwatches;

    if(origin == "main-product") {
        firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[0].querySelectorAll('.swatch-element');
    } else if(origin == "tile"){
        firstVariantSiblingSwatches = document.querySelector(`${selector}`) && document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0] ? document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0].querySelectorAll('.swatch-element') : null;
    } else {
        firstVariantSiblingSwatches = document.querySelector(`${selector}`).querySelectorAll('.swatches-container .swatch')[0].querySelectorAll('.swatch-element');
    }
    if(firstVariantSiblingSwatches){
        let checkedInputIndex = origin == "main-product" ? [...firstVariantSiblingSwatches].findIndex(element => element.querySelector('input[type="radio"]:checked')) : [...firstVariantSiblingSwatches].findIndex(element => element.classList.contains('selected'));
        
        if((checkedInputIndex + 2) < firstVariantSiblingSwatches.length){
            secondSwatchIndex = checkedInputIndex + 1;
            secondSwatchValue = firstVariantSiblingSwatches[secondSwatchIndex].getAttribute('data-value');
        } else if (firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[1]) {
            option_number = 2;
            firstVariantSiblingSwatches = document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container.options .swatch`)[1].querySelectorAll('.swatch-element');
            checkedInputIndex = [...firstVariantSiblingSwatches].findIndex(element => element.querySelector('input[type="radio"]:checked'));
            if((checkedInputIndex + 2) < firstVariantSiblingSwatches.length){
                secondSwatchIndex = checkedInputIndex + 1;
                secondSwatchValue = firstVariantSiblingSwatches[secondSwatchIndex].getAttribute('data-value');
            }
        }

        secondVariant = product.variants.filter(obj => obj[`option${option_number}`] === secondSwatchValue);
        firstSecondVariant.push(firstVariant);
        firstSecondVariant.push(secondVariant[0]);
    }
    return firstSecondVariant;
}

const returnImageUrls = function(product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower){
    let imageUrlsArray = [];
    if(origin == "bundle-builder-sub-images" || origin == "bundle-builder-overlay-images"){        
        let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
        let firstVariantString = origin == "bundle-builder-sub-images" ? variant_data[`${firstVariant.id}`]['image_url'] : variant_data[`${firstVariant.id}`]['bundle_builder_image']['default'];
        imageUrlsArray.push(`${firstVariantString}${widthIndicator}`)
        imageUrlsArray.push(`${firstVariantString}${widthIndicatorLower}`)
        if(secondVariant){
            let secondVariantString = origin == "bundle-builder-sub-images" ? variant_data[`${secondVariant.id}`]['image_url'] : variant_data[`${secondVariant.id}`]['bundle_builder_image']['default'];
            imageUrlsArray.push(`${secondVariantString}${widthIndicator}`);
            imageUrlsArray.push(`${secondVariantString}${widthIndicatorLower}`)
        }
    } else {
        let firstVariantImagesSelectionString = origin == "main-product" ? firstVariant.featured_media.alt : undefined;
        let firstVariantImageUrlsArray = origin == "main-product" ? product.media.filter(obj => obj[`alt`] === firstVariantImagesSelectionString) : [firstVariant.featured_media];
        
        if(firstVariantImageUrlsArray.length > 0){
            firstVariantImageUrlsArray.forEach((url) => {
                if(origin == "main-product"){
                    imageUrlsArray.push(url.src  + widthIndicator)
                    imageUrlsArray.push(url.src  + widthIndicatorLower)
                } else {
                    imageUrlsArray.push(url.preview_image.src  + widthIndicator)
                    imageUrlsArray.push(url.preview_image.src  + widthIndicatorLower)
                }
            })
        }
        if(secondVariant && secondVariant.featured_media){
            let secondVariantImagesSelectionString = secondVariant.featured_media.alt;
            let secondVariantImageUrlsArray = origin != "tile" ? product.media.filter(obj => obj[`alt`] === secondVariantImagesSelectionString) : [secondVariant.featured_media];;
            if(secondVariantImageUrlsArray.length > 0){
                secondVariantImageUrlsArray.forEach((url) => {
                    if(origin != "tile"){
                        imageUrlsArray.push(url.src + widthIndicator)
                        imageUrlsArray.push(url.src + widthIndicatorLower)
                    } else {
                        imageUrlsArray.push(url.preview_image.src  + widthIndicator)
                        imageUrlsArray.push(url.preview_image.src  + widthIndicatorLower)
                    }
                })
            }
        }
    }
    


    return imageUrlsArray;
}

window.Branch.product.preloadImages = function(product, type, origin, selector) {
    let imageUrls = [];
    let sizes_string = "100vw";
    let image_selector

    if(origin == "bundle-builder-sub-images"){
        sizes_string = "(max-width:1167px) calc(50vw-275px), calc(((((100vw-84px))*0.55)-14px)/2)";
        image_selector = '.bundle-builder-gallery .bundle-builder-gallery__image.second_img_chair'
    } else if(origin == "bundle-builder-overlay-images"){
        sizes_string = "(max-width:900px) 100vw, (max-width:1167px) calc(100vw-538px), calc(((100vw-84px))*0.55)";
        image_selector = '.bundle-builder-gallery .bundle-builder-gallery__image.chairs'
    } else if(origin == "main-product" || origin == "product"){
        sizes_string = "(max-width:600px) 100vw, (max-width:900px) calc(100vw-48px), (max-width:1167px) calc(((100vw-48px))-490px), calc(((100vw-84px))*0.55)"
        image_selector = '.main-product .main-product__main-product-image'
    } else if(origin == 'toggle-header') {
        sizes_string = "(max-width: 599px) calc(((100vw - 52px) - (0.66666 * 24px)) / 1.66666), (max-width: 899px) calc(((100vw - 52px) - (1.66666 * 24px)) / 2.66666), (max-width: 1023px) calc((((100vw - 160px) * 0.6) - (0.3333 * 24px)) / 1.3333), (max-width: 1199px) calc((((100vw - 220px) * 0.6) - (1.3333 * 24px)) / 2.3333), (max-width: 1439px) calc((((100vw - 280px) * 0.7) - (2 * 24px)) / 3), calc(((1160px * 0.7) - (2 * 24px)) / 3)"
        image_selector = '.toggle-header-products-list__carousel-inner .product-tile .product-image-container img:not(.pre-loaded)'
    } else {
        sizes_string = "(max-width:600px) calc(100vw-48px), (max-width:840px) calc(((100vw-148px))/2), (max-width:900px) calc(((77.77vw-20px))/2), (max-width:1440px) calc(((77.77vw-40px))/3), calc(((1120px-40px))/3)"
        image_selector = '.product-tile .product-image-hover__image'
    }

    let currentSrcSet = document.querySelector(`${image_selector}`).getAttribute('srcset');

    const srcSetWidthsArray = currentSrcSet.match(/\d+w/g).map(s => parseInt(s));
    const viewportWidth = window.innerWidth;
    const devicePixelRatio = window.devicePixelRatio;

    const widthIndicatorArray = selectSrcset(srcSetWidthsArray, sizes_string, viewportWidth, devicePixelRatio);
    const widthIndicator = widthIndicatorArray[0];
    const widthIndicatorLower = widthIndicatorArray[1]


    if(type == "click" && origin == "main-product"){
        let tempImageUrls = product.media.filter(obj => obj.media_type === 'image').map(obj => obj.src);
        tempImageUrls.forEach((url) => {
            imageUrls.push(`${url}${widthIndicator}`);
            imageUrls.push(`${url}${widthIndicatorLower}`);
        })
    } else if(type == "click" && origin == "tile"){
        if(product.variants.length > 0){
            let variants_featured_media = product.variants.map(variant => variant.featured_media);
            let tempImageUrls = [...new Set(variants_featured_media.map(obj => obj.src))];
            tempImageUrls.forEach((url) => {
                imageUrls.push(`${url}${widthIndicator}`);
                imageUrls.push(`${url}${widthIndicatorLower}`);
            })
        }
    } else if(type == "click" && origin == "bundle-builder-overlay-images"){
        let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
        
        for (const [key, value] of Object.entries(variant_data)) {
            imageUrls.push(value['bundle_builder_image']['default'] + widthIndicator);
            imageUrls.push(value['bundle_builder_image']['default'] + widthIndicatorLower);     
            if(value['bundle_builder_image']['special-conditions'] && value['bundle_builder_image']['special-conditions'].length > 0){
                value['bundle_builder_image']['special-conditions'].forEach((specialCondition) => {
                    imageUrls.push(specialCondition['default-image-url'] + widthIndicator);
                    imageUrls.push(specialCondition['default-image-url'] + widthIndicatorLower);
                    if(specialCondition['option-matches'] && specialCondition['option-matches'].length > 0){
                        specialCondition['option-matches'].forEach((optionMatch) => {
                            imageUrls.push(optionMatch['image-url'] + widthIndicator);
                            imageUrls.push(optionMatch['image-url'] + widthIndicatorLower);
                        })
                    }
                })
            }
            }
    } else if(type == "click" && origin == "bundle-builder-sub-images"){
        if(product.variants.length > 0){
            const updateArrayWithBundleData = (product_variants, bundle_data, arr) => arr.push(...Object.values(product_variants).map(variant => bundle_data[variant.id]));
            let relevantBundleData = [];
            let variant_data = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML);
            updateArrayWithBundleData(product.variants, variant_data, relevantBundleData);
            relevantBundleData.forEach((data_line) => {
                imageUrls.push(data_line['image_url'] + widthIndicator);
                imageUrls.push(data_line['image_url'] + widthIndicatorLower)
            })
        }
  } else if (origin == 'toggle-header') {
        let toggle_header_image_urls = [];
        let indicatorArray = [];
        document.querySelectorAll('.toggle-header-products-list__carousel-inner .product-tile .product-image-container img:not(.pre-loaded)').forEach(img => { if (!toggle_header_image_urls.includes(img.src)) toggle_header_image_urls.push(img.src); });

        indicatorArray.push(widthIndicator);
        indicatorArray.push(widthIndicatorLower);
        indicatorArray.forEach((indicator) => {
            toggle_header_image_urls.forEach((toggle_header_image_url) => {
                imageUrls.push(`${toggle_header_image_url}${indicator}`)
            })
        })
            
    } else {
            if(product.variants && product.variants.length > 1){
                let firstSecondVariant = window.Branch.product.returnFirstSecondVariant(product, origin, selector);
                let firstVariant = firstSecondVariant[0];
                let secondVariant = firstSecondVariant[1];

                if(firstVariant){
                    imageUrls = returnImageUrls(product, firstVariant, secondVariant, origin, widthIndicator, widthIndicatorLower);
                }
            } 
        }


    var loadedCount = 0;
    var totalImages = imageUrls.length;
    function checkAllImagesLoaded() {
        loadedCount++;
        // console.log('loadedCount', loadedCount)
        if (loadedCount === totalImages) {
            // console.log('all images pre-loaded');
            if(origin == 'toggle-header'){
                if(document.querySelector('.toggle-header__outer')){
                    document.querySelector('.toggle-header__outer').setAttribute('data-all-product-images-loaded', true)
                }
            }
        }
      }

    imageUrls.forEach(function(url) {
        var img = new Image();
        img.onload = checkAllImagesLoaded;
        img.onerror = checkAllImagesLoaded; // Handle errors loading images
        img.src = url;
      });
  }

  const selectSrcset = (srcsetArray, sizes, viewportWidth, devicePixelRatio) => {
    const srcsetCandidates = srcsetArray.map((item, index) => {
      const width= item;
      return { width: parseInt(width), index: index };
    });
  
    const evaluateCalc = (calcStr) => {
      const expression = calcStr.replace(/calc\(([^)]+)\)/g, (_, expr) => expr.replace(/(\d+(\.\d+)?)vw/g, (match, num) => `((${num} / 100) * ${viewportWidth})`)).replaceAll('px', '');
      return Function(`"use strict";return (${expression})`)();
    };
  
    const intendedSize = sizes.split(',').reverse().reduce((acc, size) => {
      let [condition, value] = size.trim().split(/\s+/);
      if(!value){
        value = condition
        condition = undefined
      }
      let maxWidthMatch = undefined;
      if(condition){
        maxWidthMatch = condition.match(/\((max-width:\s*(\d+)px)\)/);
      }
      if (!maxWidthMatch || maxWidthMatch && viewportWidth <= parseInt(maxWidthMatch[2])) {
        let vwValue = value.includes('vw') ? viewportWidth * (parseInt(value) / 100) : value;
        return value.includes('calc') ? evaluateCalc(value) : parseInt(vwValue);
      }
      return acc;
    }, viewportWidth);
  
    const requiredWidth = intendedSize * devicePixelRatio;
    const returnBestCandidate = (srcsetCandidates, requiredWidth) => srcsetCandidates.find(candidate => candidate.width > requiredWidth);

    let bestCandidatesArray = []

    let bestCandidate = returnBestCandidate(srcsetCandidates, requiredWidth);
    let bestCandidateString = bestCandidate ? `&width=${bestCandidate.width}` : `&width=${srcsetCandidates[srcsetCandidates.length - 1].width}`;
    let secondBestCandidateString = bestCandidate && srcsetCandidates[bestCandidate.index - 1] ? `&width=${srcsetCandidates[bestCandidate.index - 1].width}` : `&width=${srcsetCandidates[srcsetCandidates.length - 2].width}`;

    bestCandidatesArray.push(bestCandidateString)
    bestCandidatesArray.push(secondBestCandidateString)

    return bestCandidatesArray;
  };

window.Branch.product.initSwatchClickListener = function(product, isQuickView, type, selector){
    if(product.id){
        let swatchContainers = isQuickView ? document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container[data-clicked="false"]`) : document.querySelectorAll(`.main-product .add-to-cart-form[data-product-id="${product.id}"] .swatches-container[data-clicked="false"], #mobile-sticky-atc`);
        if(type == 'tile'){
            swatchContainers = document.querySelectorAll(`${selector}`);
        }

        function clickHandler() {
        // Execute the callback function
        if(product.media.length > 0){
            let containerSelector = `.main-product .main-product__item#main-product-item-${product.id}`;
            window.Branch.product.preloadImages(product, 'click', type, containerSelector);
        }
        // Remove the click event listener after it's clicked once
        swatchContainers.forEach((swatchContainer) => {
            swatchContainer.removeEventListener('click', clickHandler);
          })
      }
      swatchContainers.forEach((swatchContainer) => {
        swatchContainer.addEventListener('click', clickHandler);
      })
    }
}

window.Branch.product.returnMatchCriteriaObject = function(variantMatchData, selectProductOptions, addOnProduct){
    let matchCriteriaObject = {};
    variantMatchData.forEach((variantMatch) => {
        let index = addOnProduct['options'].findIndex(item => item.toLowerCase() === variantMatch['add-on-option-name'].toLowerCase());
        if(index > -1){
            let nameMatch = variantMatch['option-name'].toLowerCase();
            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                variantMatch['non-identical-values-to-match'].forEach((nonIdenticalValueToMatch) => {
                    if(variantMatch['option-name'].toLowerCase() == nonIdenticalValueToMatch['value'].toLowerCase()){
                        nameMatch = nonIdenticalValueToMatch['add-on-value'].toLowerCase()
                    }
                }) 
            }
            let value = selectProductOptions[Object.keys(selectProductOptions).find(key => key.toLowerCase() === nameMatch)];

            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                let nonIdenticalValueToMatch = variantMatch['non-identical-values-to-match'].find((match) => match['value'] == value);
                if(nonIdenticalValueToMatch){
                    value = nonIdenticalValueToMatch['add-on-value']
                }
            }
            
            if(!matchCriteriaObject[`${index}`]){
                matchCriteriaObject[`${index}`] = [];
            }
            matchCriteriaObject[`${index}`].push(value);
        }
    })
    return matchCriteriaObject
}

window.Branch.product.returnMatchingVariantAddOn = function(selectedProduct, addOnHandle, addOnProduct, origin){
    let matchingVariantAddOn = addOnProduct['variants'][0];
    let selectedProductId = selectedProduct['product_id'];
    let bundleVariantMatchesData;

    if (typeof bundle_variant_matches_data === 'undefined' || bundle_variant_matches_data === null) {
        if (origin == 'side-cart') {
            bundleVariantMatchesData = selectedProduct.addon_matches;
        } else if(origin == 'main-product'){
            bundleVariantMatchesData = document.querySelector('#bundle-variant-matches').innerHTML ? JSON.parse(document.querySelector('#bundle-variant-matches').innerHTML) : [];
        }
    } else {
        bundleVariantMatchesData = bundle_variant_matches_data;
    }

    let variantMatchData;
    if(bundleVariantMatchesData){
        if(origin == 'main-product' || origin == 'side-cart'){
            variantMatchData = bundleVariantMatchesData.length > 0 && bundleVariantMatchesData.find(item => item['add-on-handle'] === addOnHandle) ? bundleVariantMatchesData.find(item => item['add-on-handle'] === addOnHandle)['variant-matches'] : null;
        } else {
            variantMatchData = bundleVariantMatchesData[selectedProductId] && bundleVariantMatchesData[selectedProductId].find(item => item['add-on-handle'] === addOnHandle) ? bundleVariantMatchesData[selectedProductId].find(item => item['add-on-handle'] === addOnHandle)['variant-matches'] : null;
        }
    }

    if(variantMatchData){
        let selectProductOptions = origin == 'side-cart' ? selectedProduct['options'] : JSON.parse(selectedProduct['options'].replace(/'/g, '"'));
        let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(variantMatchData, selectProductOptions, addOnProduct);        
        let matchingVariant = addOnProduct['variants'].find(variant =>
            Object.entries(matchCriteriaObject).every(([index, values]) =>
                values.includes(variant.options[index])
            )
        );

        if(matchingVariant){
            matchingVariantAddOn = matchingVariant;
        }
    }

    return matchingVariantAddOn;
}

window.Branch.product.selectCorrectAddon = function(container, isAddOnsTab, productsArray, origin){
    let addOnId = parseInt(container.querySelector('.main-product .add-to-cart-form').getAttribute('data-product-id'));
    let addOnHandle = container.querySelector('.main-product .add-to-cart-form .select-variant').getAttribute('data-handle');
    let addOnProduct = origin == 'main-product' || origin == 'side-cart' ? productsArray[`${addOnId}`] : productsArray.find(product => product.id === addOnId);

    let productInputs = document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] .swatches-container .swatch-element input[type=radio]`);
    let selectInput = document.querySelector(`.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] input#product-${addOnId}-variant`);
    let productSelector = `.main-product__item .add-to-cart-form[data-product-id="${addOnId}"] .swatches-container`;

   if(isAddOnsTab == true){
    let selectedChairDeskProducts = [selectVariantsArray[0][0], selectVariantsArray[1][0]];



    let matchFound = false;
    selectedChairDeskProducts.forEach((selectedProduct) => {
        if(matchFound == false){
            let selectedProductAddons = product_data[`${selectedProduct[`product_id`]}`]['addon_handles'].split(',');

            if (selectedProductAddons.some(e => e.trim() == addOnHandle)) {
                matchFound = true;
                let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct);
                window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'bundle-builder-pop-up', addOnProduct, bundlePricingDataArray);

                /* Check if variant is a bundle product, and if so update the 'bundle-products' input */

                if(variant_data[newProductAddOn.id][`constituents`] && JSON.parse(variant_data[newProductAddOn.id][`constituents`].replace(/'/g, '"')).length > 0){
                    window.Branch.product.updateOldStyleBundle(newProductAddOn.id, addOnId , "bundle-builder")
                }          
              }
        }
    })
   } else if(origin == "main-product"){
    let selectedProduct = {};
    let options_string = '';
 
    if(selected_main_product.selected_variant.option1){
        options_string = `'${selected_main_product.options[0]}': '${selected_main_product.selected_variant.option1}'`;
    }
    if(selected_main_product.selected_variant.option2){
        options_string = `${options_string}, '${selected_main_product.options[1]}': '${selected_main_product.selected_variant.option2}'`;
    }
    if(selected_main_product.selected_variant.option3){
        options_string = `${options_string}, '${selected_main_product.options[2]}': '${selected_main_product.selected_variant.option3}'`;
    }
    options_string = `{ ${options_string} }`;

    selectedProduct['options'] = `${options_string}` 
    selectedProduct['product_id'] = selected_main_product.id;
    selectedProduct['variant_id'] = `${selected_main_product.selected_variant.id}`


    if(addOnProduct){
        let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct, origin);
        window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'main-product-pop-up', addOnProduct, undefined);
    }

   }  else if(origin == "side-cart"){
    let selectedProductId = document.querySelector(`#side-cart .cart-addons .item`).getAttribute('data-main-product-variant')
    let selectedProduct = JSON.parse(document.querySelector(`#variant_data-side-cart`).innerText)[`${selectedProductId}`];
    let newProductAddOn = window.Branch.product.returnMatchingVariantAddOn(selectedProduct, addOnHandle, addOnProduct, origin);
    
    // console.log('selectedProduct', selectedProduct)

    window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'main-product-pop-up', addOnProduct, undefined, 'side-cart');
   }
   else {
    let newProductAddOn = addOnProduct['variants'][0];
    window.Branch.product.selectVariantOnLoad(addOnId, newProductAddOn, productInputs, selectInput, productSelector, 'bundle-builder-pop-up', addOnProduct, bundlePricingDataArray);

    /* Check if variant is a bundle product, and if so update the 'bundle-products' input */

    if(variant_data[newProductAddOn.id][`constituents`] && JSON.parse(variant_data[newProductAddOn.id][`constituents`].replace(/'/g, '"')).length > 0){
        window.Branch.product.updateOldStyleBundle(newProductAddOn.id, addOnId , "bundle-builder")
    }  
   }
   if(selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container') && selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container').getAttribute('data-initialized') == 'false'){
        selectInput.closest('.add-to-cart-form').querySelector('.product-buttons__container').setAttribute('data-initialized', true);
    }
};

window.Branch.product.updateAddonTile = function(addonsContainerItem, matchingVariant, type){
    addonsContainerItem.setAttribute('data-display-variant', `${matchingVariant.id}`);
    let variantPricingSelector = type && type == 'side-cart' ? '.cart-items' : ''

    /* Update addon tile image */
    let image = addonsContainerItem.querySelector(`.addon-img img:not(.addons_lifestyle-image)`);
    let addonProductId = parseInt(addonsContainerItem.querySelector(`input.checkbox-custom`).getAttribute('data-addon-id'))
 
    image.setAttribute('src', matchingVariant.featured_image.src)
    image.setAttribute('data-src', matchingVariant.featured_image.src)

    image.setAttribute('srcset', window.Branch.functions.returnSrcSet(matchingVariant.featured_image.src))

    /* Update addon tile price */
    let variantPricing;
    if(type == 'side-cart'){
        variantPricing = JSON.parse(document.querySelector(`#full-side-cart-addons-pricing-data`).innerText)[`${addonProductId}`];

    } else {
        variantPricing = JSON.parse(document.querySelector(`#full-pdp-addons-pricing-data`).innerText)[`${addonProductId}`];
    }
    
    let variantPrice = variantPricing[`${matchingVariant.id}`];
    
    let currentPriceRatio = variantPrice.cpx * parseInt(addonsContainerItem.getAttribute('data-quantity-ratio'))
    let originalPriceRatio = variantPrice.opx * parseInt(addonsContainerItem.getAttribute('data-quantity-ratio'))

    if(variantPrice.bdx && variantPrice.bdx > 0){
        currentPriceRatio = currentPriceRatio * ((100 - variantPrice.bdx)/100);
        if(originalPriceRatio == 0){
            originalPriceRatio = variantPrice.cpx;
        }
    }

    let priceString = `+${Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`
    let originalPriceString = `${Shopify.formatMoney(originalPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`

    if(addonsContainerItem.getAttribute('data-modification-price-replacement-text')){
        priceString = addonsContainerItem.getAttribute('data-modification-price-replacement-text')
    }

    if(addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')){
        originalPriceString = addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')
    }

    if(addonsContainerItem.getAttribute('data-modification-price-replacement-text') && !addonsContainerItem.getAttribute('data-modification-compare-at-price-replacement-text')){
        originalPriceString = `+${Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ','')}`;
    }

    addonsContainerItem.querySelector('span.addon-price').innerHTML = priceString;
    if(addonsContainerItem.querySelector('span[data-price="retail"]')){
        addonsContainerItem.querySelector('span[data-price="retail"]').innerHTML = originalPriceString;
        if(currentPriceRatio < originalPriceRatio){
            addonsContainerItem.querySelector('.price .retail').setAttribute('data-visible', true);
        } else {
            addonsContainerItem.querySelector('.price .retail').setAttribute('data-visible', false);
        }
    }
}

const updateAddonQuantity = function(container, addOnData, origin){
    let addOnId = parseInt(container.querySelector('.main-product .add-to-cart-form').getAttribute('data-product-id'));
    let quantityRatio = 1;
    if(origin == "side-cart" && document.querySelector(`#side-cart .cart-addons input[data-addon-id="${addOnId}"]`)){
        quantityRatio = parseInt(document.querySelector(`#side-cart .cart-addons input[data-addon-id="${addOnId}"]`).closest('.item').getAttribute('data-quantity-ratio'))
     } else if(document.querySelector(`.main-product .addons__container .addons .item input[data-addon-id="${addOnId}"]`)){
        quantityRatio = parseInt(document.querySelector(`.main-product .addons__container .addons .item input[data-addon-id="${addOnId}"]`).closest('.item').getAttribute('data-quantity-ratio'));
     }
    container.querySelector('.main-product__item').setAttribute('data-quantity-ratio', quantityRatio);
    if(quantityRatio > 1){
        let currentTitle = container.querySelectorAll('.main-product__title h1')[0].innerHTML;
        container.querySelectorAll('.main-product__title h1').forEach((mainTitle) => {
            mainTitle.innerHTML = `${currentTitle} (x${quantityRatio})`
        });
    }

    let bundle = false;
    if(addOnData && addOnData[`${addOnId}`] && addOnData[`${addOnId}`].tags && addOnData[`${addOnId}`].tags.length > 0){
        if(addOnData[`${addOnId}`].tags.indexOf("bundle") !== -1)  {
            bundle = true;
        }
    }

    if(origin == "side-cart"){
        let clickSpan = container.querySelector('.addon-add-btn .content-available span');
        if(clickSpan){
            clickSpan.setAttribute('onclick', `addToCartAddOns(${addOnId}, ${bundle}, ${quantityRatio})`)
        }

    } 
}

window.Branch.product.quickViewUpdateOnOpen = function(modal, container, origin, isAddOnsTab){
    container.setAttribute('data-initialized', true);
    let closeButton = container.querySelector('.tingle-modal__close');
    let modalBox = container.querySelector('.tingle-modal-box');
    
    modalBox.appendChild(closeButton);

    if(origin == 'bundle-builder-form' && products && products.length > 0){
        let atc_button = container.querySelector('#bundle-builder-addon');
        if(atc_button){
        window.Branch.product.selectCorrectAddon(container, isAddOnsTab, products);

        atc_button.addEventListener('click', function(e){
        e.preventDefault();
        let selectElement = container.querySelector('select.select-variant');
        let productId = parseInt(container.querySelector('form.add-to-cart-form').getAttribute('data-product-id'));
        window.Branch.bundle.handleAddOnClick(parseInt(selectElement.value), productId, selectElement.getAttribute('data-handle'));
        modal.close();
        })
        }
    } else if(origin == 'comparison-chart' && document.querySelector('body.template-page-bundles')){
        window.Branch.bundle.updateComparisonChart(container.querySelector('.comparison-chart-section'));
        
    } else if(origin == 'main-product'){
        let productId = parseInt(document.querySelector(`.main-product[data-quick-view="false"] .main-product__item`).getAttribute('id').replaceAll('main-product-item-', ''));
        let addOnData = document.querySelector(`#add_on_product_data--${productId}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${productId}`).innerHTML) : {};
        if(Object.values(addOnData).length > 0){
            updateAddonQuantity(container, addOnData, origin)
            window.Branch.product.selectCorrectAddon(container, isAddOnsTab, addOnData, origin);
        }
    } else if(origin == 'side-cart'){
        let addOnData = document.querySelector(`#add_on_product_data-side-cart`) ? JSON.parse(document.querySelector(`#add_on_product_data-side-cart`).innerHTML) : {};
        // console.log('addOnData', addOnData)
        if(Object.values(addOnData).length > 0){
            updateAddonQuantity(container, addOnData, origin)
            window.Branch.product.selectCorrectAddon(container, isAddOnsTab, addOnData, origin);    
        }
    }
}

const insertGalleryLoadingOverlay = function(selected_variant, product){
    let img_url = selected_variant['featured_image'];
    if(img_url){
        const galleryLoadingOverloadContainer = document.createElement("div");
        galleryLoadingOverloadContainer.classList.add('gallery-loading-overlay-container');
        let galleryLoadingOverloadInnerHTML = `
        <div class="gallery-loading-overlay-container-inner">
            <img
            srcset="${img_url.src}&width=180"
            width="540"
            height="540"
            class="gallery-loading-overlay-container-image"
            alt="${img_url.alt}"                      
            loading="eager"       
        >
        </div>
        `;
        galleryLoadingOverloadContainer.innerHTML = galleryLoadingOverloadInnerHTML;
        let gallery = document.querySelector(`.main-product .main-product-gallery[data-product-id="${product.id}"]`)
        gallery.appendChild(galleryLoadingOverloadContainer);
    }
}

window.Branch.product.selectVariantOnLoad = function(productId, selected_variant, productInputs, selectInput, productSelector, type, product, bundlePricingDataArray, placement){
    if (productInputs.length > 0) {
        productInputs.forEach((productInput) => {
            var $input = productInput;
            var name = productInput.getAttribute('name') + '-' + productId;
            $input.setAttribute('name', name);
        });
    }

    if(type == "bundle-builder-pop-up" || type == 'main-product-pop-up'){
        window.Branch.product.updateDiscountCodePrice(selected_variant, product, type, bundlePricingDataArray, placement);
        insertGalleryLoadingOverlay(selected_variant, product);
    }

    selected_variant.options.forEach(function(option, index) {
        var swatch_selector = '[data-option-index="' + index + '"] .swatch-element[data-value="' + option + '"]';

        if (document.querySelector(productSelector)) {
            var $swatch = document.querySelector(productSelector).querySelector(swatch_selector);
            if ($swatch != null) {
                if(type == 'bundle-builder-form'){
                    $swatch.classList.add('selected');
                }
                else {
                    $swatch.querySelector('input[type="radio"]').checked = true;
                }
            }
        }
    });
    

    selectInput.setAttribute('value', selected_variant.id);
    selectInput.value = selected_variant.id;

    selectElement = selectInput.parentElement.querySelector('select.select-variant');
    if(selectElement){
        selectElement.value = `${selected_variant.id}`;
    }

    let selectors = selectInput.closest('.add-to-cart-form') ? selectInput.closest('.add-to-cart-form').querySelectorAll(".single-option-selector") : [];

    if(selectors.length > 0){
        if(selected_variant.options[0] && selectors[0]){
            selectors[0].value = selected_variant.options[0];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[0].dispatchEvent(event);
        }

        if(selected_variant.options[1] && selectors[1]){
            selectors[1].value = selected_variant.options[1];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[1].dispatchEvent(event);
        }

        if(selected_variant.options[2] && selectors[2]){
            selectors[2].value = selected_variant.options[2];
            const event = new Event('change', {
                'bubbles': true,
                'cancelable': true
            });
            selectors[2].dispatchEvent(event);
        }
    }
}

const mainProductReformat = function(){
    openCloseAccordionSlides();
    window.Branch.product.formatSwatches();
    window.Branch.product.resizeSwatchesHeader(`.main-product`);
    window.Branch.product.customSwatchContainerResize(`.main-product`);
    window.Branch.product.formatPreOrderSwatch();
}

const initMainProductSection = function(){
    window.Branch.product.initAccordion();
    let firstAccordionHeader = document.querySelector('.main-product__accordion .main-product__accordion-li[data-index="0"] .main-product__accordion-header-container');

    if (firstAccordionHeader) {
        const onScroll = function() {
            firstAccordionHeader.click();
            window.removeEventListener('scroll', onScroll);
        };
        window.addEventListener('scroll', onScroll);
    }
}

window.Branch.product.updateOldStyleBundle = function(variant_id, product_id , origin){
    if(origin == "bundle-builder"){
        let constituentsArrayString = JSON.parse(document.querySelector('#bundle-variant-data').innerHTML)[`${variant_id}`]['constituents'];
        let constituentsArray = JSON.parse(constituentsArrayString.replace(/'/g, '"'));
        let bundleInput = document.querySelector(`#main-product-item-${product_id} .add-to-cart-form .bundle-products`);
        if(bundleInput){
            bundleInput.value = JSON.stringify(constituentsArray);
            bundleInput.setAttribute('value', JSON.stringify(constituentsArray));
        }
    }
}

const checkIfIncompatible = function(product, variant, selectedAddon, addOnVariantMatches, addOnProduct, addOnProductHandle, variantMatches){
    let mismatched = true;
    let currentAddOnVariant = Object.values(addOnProduct.variants).find(entry => entry['id'] === selectedAddon['variantId']);
    let productOptions = addOnProduct.options.map(name => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
    let productOptionValues = currentAddOnVariant.options;
        
    if(variantMatches && mismatched == true){
        let matchesFullfilled = 0;
        let nonCompulsoryMatchConditions = 0;
        let nonCompulsoryMatchConditionsMet = false;

        variantMatches.forEach((variantMatch) => {
            if(variantMatch['match-not-required-if-other-options-match'] == true) {
                nonCompulsoryMatchConditions = nonCompulsoryMatchConditions + 1;
            }
        });
        variantMatches.forEach((variantMatch) => {
            if(variantMatch['non-compulsory-match'] == true){
                matchesFullfilled = matchesFullfilled + 1
            } else {
                productOptions.forEach((productOption, index) => {
                    if(variantMatch['add-on-option-name'].toLowerCase().replace(' ', '-') == productOption){
                        let value = productOptionValues[index];
                        let optionIndex = product['options'].findIndex(item => item.toLowerCase() === variantMatch['option-name'].toLowerCase());
                        let variantOptionValue = variant.options[optionIndex]
                        let matchValue = variantOptionValue;

                            if(variantMatch['non-identical-values-to-match'] && variantMatch['non-identical-values-to-match'].length > 0){
                                let productOptionValue = productOptionValues[`${index}`].replaceAll('@', ',');
                                variantMatch['non-identical-values-to-match'].forEach((nonIdenticalMatch) => {
                                    if(nonIdenticalMatch['value'] == variantOptionValue && nonIdenticalMatch['add-on-value'] == productOptionValue){
                                        matchValue = nonIdenticalMatch['add-on-value'];
                                        matchesFullfilled = matchesFullfilled + 1;
                                    }
                                })
                            } else if(value === matchValue){
                                if(variantMatch['match-not-required-if-other-options-match'] == true && nonCompulsoryMatchConditionsMet == false){
                                    matchesFullfilled = matchesFullfilled + nonCompulsoryMatchConditions;
                                    nonCompulsoryMatchConditionsMet = true;
                                } else if(!variantMatch['match-not-required-if-other-options-match']) {
                                    matchesFullfilled = matchesFullfilled + 1;
                                }
                            }                 
                    }
                })
            }
        })

        if(matchesFullfilled >= variantMatches.length){
            mismatched = false;
        }
        // console.log('mismatched', mismatched, 'matchesFullfilled', matchesFullfilled, 'variantMatches.length', variantMatches.length)
    }
    return mismatched;
}

window.Branch.product.updateSelectedAddons = function(product, variant){
    let selectedAddons = document.querySelector('#addon-products-for-atc') && document.querySelector('#addon-products-for-atc').getAttribute('value') ? JSON.parse(document.querySelector('#addon-products-for-atc').getAttribute('value')) : [];
    if(selectedAddons.length > 0){
        let matchesData = document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`) && document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML ? JSON.parse(document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML) : [];
        let addOnData = document.querySelector(`#add_on_product_data--${product.id}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${product.id}`).innerHTML) : {};
        let msbdData = document.querySelector(`#variant_ship_date_metafield_values--${product.id}`) ? JSON.parse(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`).innerHTML) : {};
        let selectProductOptions = {};
        if(product.options.length > 0){
            product.options.forEach((option, index) => {
            let value = variant.options[index];
            selectProductOptions[`${option}`] = value; 
            })
        }
        if(matchesData.length > 0 && Object.values(addOnData).length > 0){
            selectedAddons.forEach((selectedAddon, selectedAddonIndex) => {
                let addOnProduct = Object.values(addOnData).find(entry => entry['handle'] === selectedAddon['productHandle']);
                let addonProductMatchData = matchesData.find(entry => entry['add-on-handle'] === selectedAddon['productHandle']) ? matchesData.find(entry => entry['add-on-handle'] === selectedAddon['productHandle'])[`variant-matches`] : [];
                let incompatible = checkIfIncompatible(product, variant, selectedAddon, matchesData, addOnProduct, selectedAddon['productHandle'], addonProductMatchData, addonProductMatchData);
                if(incompatible == true){
                    let matchingVariant = addOnProduct.variants[0]
                    if(addonProductMatchData.length > 0){
          
                      let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(addonProductMatchData, selectProductOptions, addOnProduct);
                      matchingVariant = addOnProduct['variants'].find(variant =>
                          Object.entries(matchCriteriaObject).every(([index, values]) =>
                              values.includes(variant.options[index])
                          )
                      );
                      let addonsContainerItem = document.querySelector(`#main-product-item-${product.id} .addons__container .addons .item input[data-addon-id="${addOnProduct.id}"]`).closest('.item');
                      if(matchingVariant && matchingVariant.featured_image && addonsContainerItem){
                            window.Branch.product.updateAddonTile(addonsContainerItem, matchingVariant);
                      }

                      selectedAddons[selectedAddonIndex] = {"productHandle": selectedAddon['productHandle'], "quantity": selectedAddon['quantity'], "variantId": `${matchingVariant.id}`, "shipping": `${msbdData[`${matchingVariant.id}`]}`, "bundle": selectedAddon.bundle, "bundleConstituents": selectedAddon.bundleConstituents, "mainProductQuantity": selectedAddon.mainProductQuantity} 
                      document.querySelectorAll(`.addons-variants .item[data-addon-handle="${selectedAddon['productHandle']}"] .swatch-element input[type="radio"]`).forEach((addonInput) => {
                        addonInput.checked = false;
                      });
                      let newVariantInput = document.querySelector(`.addons-variants .item[data-addon-handle="${selectedAddon['productHandle']}"] .swatch-element input[type="radio"][value="${matchingVariant.id}"]`);
                      if(newVariantInput){newVariantInput.checked = true};
                    }
                }
            });
            document.querySelector('#addon-products-for-atc').setAttribute('value', JSON.stringify(selectedAddons));
            document.querySelector('#addon-products-for-atc').value = JSON.stringify(selectedAddons);
        }
    }
}

window.Branch.product.updateAddonThumbnailsToMatchSelectedVariant = function(product, variant){
    let addonsContainerItems = document.querySelectorAll(`#main-product-item-${product.id} .addons__container .addons .item`)
    if(addonsContainerItems.length > 0){
    let matchesData = document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`) && document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML ? JSON.parse(document.querySelector(`#main-product-item-${product.id} #bundle-variant-matches`).innerHTML) : [];
    let addOnData = document.querySelector(`#add_on_product_data--${product.id}`) ? JSON.parse(document.querySelector(`#add_on_product_data--${product.id}`).innerHTML) : {};
     
    let selectProductOptions = {};
      if(product.options.length > 0){
        product.options.forEach((option, index) => {
          let value = variant.options[index];
          selectProductOptions[`${option}`] = value; 
        })
      }
      if(matchesData.length > 0 && Object.values(addOnData).length > 0){
        addonsContainerItems.forEach((addonsContainerItem) => {
            let checked = addonsContainerItem.querySelector(`#addon-${addonsContainerItem.querySelector('.checkbox-custom-label').getAttribute('data-addon-id')}`).checked;
            if(checked == false){


            let addOnProductHandle = addonsContainerItem.querySelector(`.checkbox-custom-label`).getAttribute('data-addon-handle');
            let addOnProductId = parseInt(addonsContainerItem.querySelector(`.checkbox-custom-label`).getAttribute('data-addon-id'));

            let addonProductMatchData = matchesData.find(entry => entry['add-on-handle'] === addOnProductHandle);
            let addOnProduct = addOnData[`${addOnProductId}`];
            if(addOnProduct) {
                let matchingVariant = addOnProduct.variants[0]
                if(addonProductMatchData){
                    addonProductMatchData = addonProductMatchData[`variant-matches`];
    
                    let matchCriteriaObject = window.Branch.product.returnMatchCriteriaObject(addonProductMatchData, selectProductOptions, addOnProduct);
                    matchingVariant = addOnProduct['variants'].find(variant =>
                        Object.entries(matchCriteriaObject).every(([index, values]) =>
                            values.includes(variant.options[index])
                        )
                    );
                }
                if(matchingVariant && matchingVariant.featured_image && parseInt(addonsContainerItem.getAttribute('data-display-variant')) != matchingVariant.id){
                    window.Branch.product.updateAddonTile(addonsContainerItem, matchingVariant);
                }
            }
            }
        })
        }
    }
}

const updateOptionsInSelector = function(selectorIndex, item, optionsMap, optionsMapAll) {
    let selectors = item.querySelectorAll(".single-option-selector")
    let selector;
    let key;

    switch (selectorIndex) {
        case 0:
            key = "root";
            selector = selectors[0];
            break;
        case 1:
            key = selectors[0].value;
            selector = selectors[1];
            break;
        case 2:
            key = selectors[0].value;
            key += " / " + selectors[1].value;
            selector = selectors[2];
            break;
    }
    
    let initialValue = selector.value;
    selector.innerHTML = ""; // Clear the existing options
    
    let options = optionsMapAll[key];
    if (options) {
        options.forEach(function(option) {
            let newOption = document.createElement("option");
            newOption.value = option;
            newOption.innerHTML = option;
            selector.appendChild(newOption);
        });
    }
    
    let availableOptions = optionsMap[key];
    let existingOptions = optionsMapAll[key];
    
    if (availableOptions && availableOptions.indexOf(initialValue) !== -1) {
        selector.value = initialValue;
    }
    
        let selected_variant_array = key.split(" / ");
        let swatches = item.querySelectorAll(".swatch");

        if(swatches.length > selected_variant_array.length){
            let finalSwatchValueCurrent = swatches[swatches.length - 1].querySelector('.swatch-element.selected') ? swatches[swatches.length - 1].querySelector('.swatch-element.selected').getAttribute('data-value') : undefined;
            if(finalSwatchValueCurrent && existingOptions && existingOptions.includes(finalSwatchValueCurrent)){
                selected_variant_array.push(finalSwatchValueCurrent);
            } else if(existingOptions) {
                selected_variant_array.push(existingOptions[0]);
            }
        }

        if(selected_variant_array.length == swatches.length){
            item.setAttribute('data-variant-description', `${selected_variant_array}`)
        }

    item.querySelectorAll('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').forEach(function(element) {
        const dataValue = element.getAttribute("data-value");
    
        if (existingOptions && existingOptions.includes(dataValue)) {
            element.removeEventListener('click', handleClick);
    
            if (availableOptions && availableOptions.includes(dataValue)) {
                element.classList.remove("soldout");
                element.querySelector("input[type='radio']").removeAttribute("checked");
                element.querySelector('.tooltip').textContent = dataValue;
            } else {
                if (!item.closest('.template-product-chat-with-sales')) {
                    element.classList.add("soldout");
                    element.querySelector("input[type='radio']").removeAttribute("checked");
                    element.querySelector('.tooltip').textContent = 'Out of stock';
                }
    
                if (window.Branch.functions.isTouchDevice()) {
                    element.addEventListener('click', handleClick);
                }
            }
    
            element.querySelector('input').disabled = false;
            element.classList.remove("option-not-available");
        } else {
            element.querySelector('input').disabled = true;
            element.querySelector('.tooltip').textContent = 'Not available';
            element.classList.add("option-not-available");
    
            if (window.Branch.functions.isTouchDevice()) {
                element.addEventListener('click', handleClick);
            }
        }
    });
    
    function handleClick() {
        const tooltip = this.querySelector('.tooltip');
        tooltip.classList.add('mobile-display');
        setTimeout(function() {
            tooltip.classList.remove('mobile-display');
        }, 2000);
    }
    
    if (availableOptions && availableOptions.indexOf(initialValue) !== -1) {
        selector.value = initialValue;
    }
};

window.Branch.product.linkOptionSelectors = function(product, item) {
    let optionsMap = {};
    let optionsMapAll = {};
    let selectors = item.querySelectorAll(".single-option-selector")

    product.variants.forEach(variant => {
        optionsMapAll.root = optionsMapAll.root || [];
        optionsMapAll.root.push(variant.option1);
        optionsMapAll.root = Shopify.uniq(optionsMapAll.root);

        if (product.options.length > 1) {
            let key = variant.option1;
            optionsMapAll[key] = optionsMapAll[key] || [];
            optionsMapAll[key].push(variant.option2);
            optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (product.options.length === 3) {
            let key = variant.option1 + " / " + variant.option2;
            optionsMapAll[key] = optionsMapAll[key] || [];
            optionsMapAll[key].push(variant.option3);
            optionsMapAll[key] = Shopify.uniq(optionsMapAll[key]);
        }

        if (variant.available) {
            optionsMap.root = optionsMap.root || [];
            optionsMap.root.push(variant.option1);
            optionsMap.root = Shopify.uniq(optionsMap.root);

            if (product.options.length > 1) {
                let key = variant.option1;
                optionsMap[key] = optionsMap[key] || [];
                optionsMap[key].push(variant.option2);
                optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }

            if (product.options.length === 3) {
                let key = variant.option1 + " / " + variant.option2;
                optionsMap[key] = optionsMap[key] || [];
                optionsMap[key].push(variant.option3);
                optionsMap[key] = Shopify.uniq(optionsMap[key]);
            }
        }
    });

    updateOptionsInSelector(0, item, optionsMap, optionsMapAll);
    if (product.options.length > 1) updateOptionsInSelector(1, item, optionsMap, optionsMapAll);
    if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);

    selectors[0].addEventListener('change', function() {
        updateOptionsInSelector(1, item, optionsMap, optionsMapAll);
        if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);
        return true;
    });

    selectors[1].addEventListener('change', function() {
        if (product.options.length === 3) updateOptionsInSelector(2, item, optionsMap, optionsMapAll);
        return true;
    });
}

var mptof_id; 
var mainProductWindowWidth;

window.addEventListener("load", function() {
    window.Branch.product.formatSwatches()
    initMainProductSection();
    initEpigraphButtons();
    formatReviewsNumber();
    mainProductWindowWidth = window.innerWidth;
    window.Branch.product.formatPreOrderSwatch();
});

window.addEventListener("resize", function() { 
    clearTimeout(mptof_id); 
    mptof_id = setTimeout(function(){
        if (window.innerWidth != mainProductWindowWidth) {
            mainProductWindowWidth = window.innerWidth
            mainProductReformat();
        }
    }, 500); 
}); 
